import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import Logomain from "../Login/Logo_oman.png";
import Logomain from "./logo_menu.png";
import { Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { baseURL } from "../../config";

const schema = Yup.object().shape({
  username: Yup.string().required("User E-Mail is required"),
  password: Yup.string()
    .required("Password is a required field")
    .min(6, "Password must be at least 6 characters"),
});

function LoginForm() {
  const [showLabel, setShowLabel] = useState(false);
  localStorage.clear();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [isEmailError, setEmailError ] = useState(null);
  const [isEmailEmpty, setisEmailEmpty] = useState(false);
  const [useremail, setIuserEmail] = useState(null);

  const usernameRef = useRef(null);
  useEffect(() => {
    // Set focus to the username input field when the component mounts
    if (usernameRef.current) {
      usernameRef.current.focus();
    }
  }, []);

  const handleModalShow = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handleModalConfirm = () => {
    // Handle the confirmation action here
    // For example, you could call an API or submit a form
    console.log("Confirm button clicked");
    handleModalClose();
  };

  const handleForgotPassword = async () => {
    if (!useremail) {
      setisEmailEmpty(true);
      return;
    }
    const raw = JSON.stringify({
      email: useremail,
    });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: raw,
    };

    const response = await fetch(`${baseURL}/resetpassword`, requestOptions);
    const result = await response.json();
    console.log(response);

    // Check if the API call was successful
    if (response.ok) {
      setisEmailEmpty(false);
      setIsEmailSent(true);
    }

    if( response.status === 404){
      console.log("hii");

      // console.log(response.message);
      setEmailError(result.message)
    }
  };

  const handleSubmit = async (values) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append(
        "Authorization",
        "Bearer 1|wOIvg3tVEQRzIta4gTImchjcJX4leMPA11sEN07A"
      );
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        username: values.username,
        password: values.password,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      // Send a POST request to your API
      const response = await fetch(
        `${baseURL}/api/auth/signin`,
        requestOptions
      );
      const result = await response.json();

      // Check if the API call was successful
      if (response.ok) {
        console.log(result);

        // Perform redirection based on the API response or any other logic
        // if (result.username) {
        if (result.code === 0) {
          setShowLabel(false);
          localStorage.setItem("username", result.data.username);
          localStorage.setItem("userrole", result.data.roles[0]);
          localStorage.setItem("userid", result.data.id);
          localStorage.setItem("employeeid", result.data.employeeid);
          localStorage.setItem("departmentid", result.data.departmentid);
          localStorage.setItem("supervisor", result.data.supervisor);
          localStorage.setItem(
            "appealcommiteememberstatus",
            result.data.belongstoappealcommittee
          );
          localStorage.setItem("profileimage", result.data.profileimage);
          navigate("/Dashboard");
        } else {
          setShowLabel(true);
        }

        //localStorage.setItem('user', result);

        // Redirect to the dashboard or another page
        //
        //window.location.href = "/";
      } else {
        // Handle unsuccessful login

        console.error("Login failed:", result.message);
      }
      // } else {
      //   setShowLabel(true);
      //   // Handle errors or display error messages to the user
      //   console.error("Failed to submit form:", response.statusText);
      // }
    } catch (error) {
      setShowLabel(true);
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        validationSchema={schema}
        initialValues={{ email: "", password: "" }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="login bg-white Small shadow">
            <div className="form Logform">
              <form className="p-4" noValidate onSubmit={handleSubmit}>
                <span>
                  {/* <img className="mx-5 pb-3" src={Logomain} width="200" /> */}
                  <img className="mx-5 pb-3" src={Logomain} width="250" />
                </span>
                <p className="logheading  text-secondary">
                  Welcome back to AMS!
                </p>

                <label>User E-Mail</label>
                <input
                  type="E-mail"
                  name="username"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  ref={usernameRef}
                  placeholder="Enter your E-Mail"
                  className="form-control inp_text bg-light"
                  id="username"
                  required={true}
                />
                <p className="error">
                  {errors.username && touched.username && errors.username}
                </p>

                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  placeholder="Enter password"
                  className="form-control inp_text bg-light"
                />

                <p className="error">
                  {errors.password && touched.password && errors.password}
                </p>
                {showLabel && (
                  <label>Login Failed. Incorrect username or password</label>
                )}

                <button
                  className="w-100 p-2 border-0 loginsubmit"
                  type="submit"
                >
                  Login
                </button>
              </form>
              {/*<span className="float-end pb-5  text-warning">Forget Password ?</span> */}
            </div>
            <p className="text-center pb-2">
              <a
                className="text-center pb-2"
                onClick={handleModalShow}
                style={{ cursor: "pointer" }}
              >
                Forget Password
              </a>
            </p>

            <Modal show={showModal} onHide={handleModalClose}>
              <Modal.Header closeButton>
                <Modal.Title>Forget Password</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <form>
                  <div>

                    {isEmailEmpty ? (
                      <label className="text-danger fw-bold">
                        {" "}
                        &times; &nbsp;Please enter your email
                      </label>
                    ) : null}
                    <br />

                    {isEmailSent ? (
                      <label className="text-success fw-bold">
                        {" "}
                        &#10004; &nbsp;Your new password is sent via email.
                        Please check your email
                      </label>
                    ) : null}
                    {/* <br /> */}

                    {isEmailError ? (
                      <label className="text-danger fw-bold">
                        {" "}
                        &times; &nbsp; {isEmailError}
                      </label>
                    ) : null}
                    <br />

                  </div>

                  <label>Enter your e-Mail</label>
                  <br></br>
                  <input
                    type="text"
                    className="w-75"
                    onChange={(e) => {
                      setIuserEmail(e.target.value);
                      setisEmailEmpty(false);
                      setEmailError(null);
                      console.log(e.target.value);
                    }}
                  ></input>
                </form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleForgotPassword}>
                  Request
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </Formik>
    </>
  );
}

export default LoginForm;
